<template>
  <div class="wrapper">
    <h1><router-link to="/">Plantalog</router-link></h1>
  </div>
</template>

<style scoped>
.wrapper {
  background-color: #3d008d;
}

h1 {
  padding: 2rem 2rem;
  margin: 0;
  font-weight: 300;
  letter-spacing: 4px;
}

a {
  text-decoration: none;
  color: #FFF;
  opacity: 0.8;
}

a:hover {
  opacity: 1;
}
</style>

